import isEqual from 'lodash/isEqual';

import type { Evaluator } from './types';

let fnString;

function compare(values, defaultResult, fn) {
  let i, result;

  if (values.length < 2) return false;

  for (i = 1; i < values.length; i++) {
    try {
      result = fn(values[0], values[i]);
      if (result !== undefined) return result;
    } catch (e) {
      return false;
    }
  }

  return defaultResult;
}

function contains() {
  return compare(arguments, true, (a, b) => {
    if (a.indexOf(b) < 0) return false;
    return undefined;
  });
}

function any() {
  return compare(arguments, false, (a, b) => {
    if (isEqual(a, b)) return true;
    return undefined;
  });
}

function eq() {
  return compare(arguments, true, (a, b) => {
    if (!isEqual(a, b)) return false;
    return undefined;
  });
}

function lt() {
  return compare(arguments, true, (a, b) => {
    if (a >= b) return false;
    return undefined;
  });
}

function gt() {
  return compare(arguments, true, (a, b) => {
    if (a <= b) return false;
    return undefined;
  });
}

function length(value) {
  return value && value.length ? value.length : 0;
}

function filter(map) {
  return Object.keys(map || {}).filter(k => {
    return !!map[k];
  });
}

fnString =
  'with(this) {' +
  '"use strict";' +
  'var contains = this.contains;' +
  'var any = this.any;' +
  'var eq = this.eq;' +
  'var lt = this.lt;' +
  'var gt = this.gt;' +
  'var get = this.get;' +
  'var length = this.length;' +
  'var filter = this.filter;' +
  'return $1;' +
  '}';

function evaluate(code, context) {
  if (code === undefined) return undefined;
  try {
    // Adding 'eslint-disable-next-line' since refactor and testing would be really tedious
    // -- Christoffer, July 25, 2016
    // eslint-disable-next-line no-new-func
    return new Function(fnString.replace('$1', code)).call(context);
  } catch (e) {
    console.error(e, code);
  }
  return undefined;
}

export default function Evaluators(data?: *): Evaluator {
  let context = {
    contains: contains,
    any: any,
    eq: eq,
    lt: lt,
    gt: gt,
    length: length,
    filter: filter,
    get: name => {
      const matches = /^([^.]*).([^$]*)/.exec(name);

      if (matches && matches.length > 2) {
        return data && data[matches[1]] && data[matches[1]][matches[2]];
      }

      return undefined;
    },
  };

  return (code?: string) => {
    return evaluate(code, context);
  };
}
